import { formatPrice } from '@uturn/portal/utils';
import { Price } from './breakdown-tooltip.types';

const getPriceCurrency = (price: Price) => {
	if ('currency' in price) {
		return price.currency;
	}

	if ('currencyCode' in price) {
		return price.currencyCode;
	}

	return 'EUR';
};

export const formatShipmentPrice = (price: Price | undefined) => {
	if (!price) {
		return undefined;
	}

	return formatPrice(price.quantity, getPriceCurrency(price));
};

export const NO_PRICE = 'N/A';

export const formatShipmentPriceLabel = (price: Price | undefined) =>
	formatShipmentPrice(price) ?? NO_PRICE;
